

export const dataCategories = 
[
    {
        "id": "01",
        "name":"RECEPTORES",
        "image":"receptores.jpg",
        "link":"/productos/receptores",
    },
    {
        "id": "02",
        "name":"AMPLIFICADORES",
        "image":"amplificadores.jpg",
        "link":"/productos/amplificadores",
    },
    {
        "id": "03",
        "name":"ALTAVOCES",
        "image":"altavoces.jpg",
        "link":"/productos/altavoces",
    },
    {
        "id": "04",
        "name":"SUBWOOFERS",
        "image":"subwoofers.jpg",
        "link":"/productos/subwoofers",
    },
    {
        "id": "05",
        "name":"PROCESADORES DE AUDIO",
        "image":"procesadores-de-sonido.jpg",
        "link":"/productos/procesadores-de-audio",
    },
    {
        "id": "06",
        "name":"ASISTENCIA AL CONDUCTOR",
        "image":"asistencia-al-conductor.jpg",
        "link":"/productos/asistencia-al-conductor",
    },
    {
        "id": "07",
        "name":"ESPECÍFICO DE VEHÍCULOS",
        "image":"vehiculos.jpg",
        "link":"/productos/receptores",
    },
    {
        "id": "08",
        "name":"MARINOS Y POWERSPORTS",
        "image":"marinos-y-receptores.jpg",
        "link":"/productos/marinos-y-powersports",
    },
    {
        "id": "09",
        "name":"ACCESORIOS",
        "image":"accesorios.jpg",
        "link":"/productos/accesorios",
    },

];










